<template>
  <input :style="`text-align: ${align}; padding: ${padding}`" class="form-control serenity__text-input" />
</template>

<script>
export default {
  props: {
    value: String,
    align: String,
    padding: String,
  },
};
</script>

<style lang="scss">
.serenity__text-input {
  height: 50px;
  background: #f8f9f8;
  border: 1px solid #f2f2f2;
  box-sizing: border-box;
  border-radius: 5px;
  padding-left: 20px;
  padding-right: 20px;
  color: #26354c;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 140%;

  ::placeholder {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 140%;
    color: #aaaeb2;
  }

  &:focus {
    outline: 0;
    background: #ffffff;
    color: #26354c;
    border: 1px solid #28aead;
    box-sizing: border-box;
    border-radius: 5px;
    box-shadow: none;
  }
}
</style>
